import { CgSpinner } from "react-icons/cg";

const Spinner = () => {
    return <CgSpinner className="text-5xl animate-spin text-blue-500"/>
}

export default Spinner;